<template>
  <section class="org-section">
    <div class="org-wrap">

      <section class="org-guide" aria-label="조직 안내">
        <h2 class="org-guide-title">조직안내 
          <!-- <small>Organization</small> -->
        </h2>

        <div class="orgchart-image">
          <img src="@/assets/picpic.png" alt="조직도 이미지" />
        </div>
      </section>

      <main class="org-executives">
        <h2 class="org-executives-title">임원현황 
          <!-- <small>Executive</small> -->
        </h2>

        <!-- 회장 -->
        <section class="exec-section" v-if="orgPresidentList.length">
          <h3 class="exec-heading">회장</h3>
          <div class="exec-card-row">
            <article
              v-for="(p, idx) in orgPresidentList"
              :key="p.id || idx"
              class="exec-card"
            >
              <div class="exec-photo" aria-hidden="true">
                <img
                  v-if="p.photoUrl"
                  :src="apiBaseUrl + p.photoUrl"
                  :alt="p.name + ' 프로필 사진'"
                />
              </div>

              <div class="exec-meta">
                <div class="exec-name">
                  <strong>{{ p.name }}</strong> <!-- ✅ 이름 매핑 -->
                  <span class="exec-role">회장</span>
                </div>
                <ul class="exec-desc">
                  <li>{{ p.orgName }}</li> <!-- ✅ 첫 번째 줄: 소속 기관명 -->
                  <li>{{ p.position }}</li> <!-- ✅ 두 번째 줄: 직책 -->
                </ul>
              </div>
            </article>
          </div>
        </section>

        <hr class="exec-divider" v-if="orgPresidentList.length" />


        <!-- 감사위원회 -->
        <section class="exec-section" v-if="orgAuditorList.length">
          <h3 class="exec-heading">감사</h3>
          <div class="exec-grid">
            <article
              v-for="(p, idx) in orgAuditorList"
              :key="p.id || `auditor-${idx}`"
              class="exec-card"
            >
              <div class="exec-photo" aria-hidden="true">
                <img v-if="p.photoUrl" :src="apiBaseUrl + p.photoUrl" :alt="p.name + ' 프로필 사진'" />
              </div>
              <div class="exec-meta">
                <div class="exec-name">
                  <strong>{{ p.name }}</strong>
                  <span class="exec-role">감사</span>
                </div>
                <ul class="exec-desc">
                  <li>{{ p.orgName }}</li>
                  <li>{{ p.position }}</li>
                </ul>
              </div>
            </article>
          </div>
        </section>

        <hr class="exec-divider" v-if="orgAuditorList.length" />

        <!-- 부회장 -->
        <section class="exec-section" v-if="orgVicePresidentList.length">
          <h3 class="exec-heading">부회장</h3>
          <div class="exec-grid">
            <article
              v-for="(p, idx) in orgVicePresidentList"
              :key="p.id || `vp-${idx}`"
              class="exec-card"
            >
              <div class="exec-photo" aria-hidden="true">
                <img v-if="p.photoUrl" :src="apiBaseUrl + p.photoUrl" :alt="p.name + ' 프로필 사진'" />
              </div>
              <div class="exec-meta">
                <div class="exec-name">
                  <strong>{{ p.name }}</strong>
                  <span class="exec-role">부회장</span>
                </div>
                <ul class="exec-desc">
                  <li>{{ p.orgName }}</li>
                  <li>{{ p.position }}</li>
                </ul>
              </div>
            </article>
          </div>
        </section>

        <hr class="exec-divider" v-if="orgVicePresidentList.length" />

        <!-- 이사 -->
        <section class="exec-section" v-if="orgDirectorList.length">
          <h3 class="exec-heading">이사</h3>
          <div class="exec-grid">
            <article
              v-for="(p, idx) in orgDirectorList"
              :key="p.id || `director-${idx}`"
              class="exec-card"
            >
              <div class="exec-photo" aria-hidden="true">
                <img v-if="p.photoUrl" :src="apiBaseUrl + p.photoUrl" :alt="p.name + ' 프로필 사진'" />
              </div>
              <div class="exec-meta">
                <div class="exec-name">
                  <strong>{{ p.name }}</strong>
                  <span class="exec-role">이사</span>
                </div>
                <ul class="exec-desc">
                  <li>{{ p.orgName }}</li>
                  <li>{{ p.position }}</li>
                </ul>
              </div>
            </article>
          </div>
        </section>

        <hr class="exec-divider" v-if="orgDirectorList.length" />

        <!-- 사무총장 -->
        <section class="exec-section" v-if="orgSecretaryGeneralList.length">
          <h3 class="exec-heading">사무총장</h3>
          <div class="exec-grid">
            <article
              v-for="(p, idx) in orgSecretaryGeneralList"
              :key="p.id || `secgen-${idx}`"
              class="exec-card"
            >
              <div class="exec-photo" aria-hidden="true">
                <img v-if="p.photoUrl" :src="apiBaseUrl + p.photoUrl" :alt="p.name + ' 프로필 사진'" />
              </div>
              <div class="exec-meta">
                <div class="exec-name">
                  <strong>{{ p.name }}</strong>
                  <span class="exec-role">사무총장</span>
                </div>
                <ul class="exec-desc">
                  <li>{{ p.orgName }}</li>
                  <li>{{ p.position }}</li>
                </ul>
              </div>
            </article>
          </div>
        </section>

        <hr class="exec-divider" v-if="orgSecretaryGeneralList.length && orgAdvisorList.length" />

        <!-- 자문위원 -->
        <section class="exec-section" v-if="orgAdvisorList.length">
          <h3 class="exec-heading">자문위원</h3>
          <div class="exec-grid">
            <article
              v-for="(p, idx) in orgAdvisorList"
              :key="p.id || `advisor-${idx}`"
              class="exec-card"
            >
              <div class="exec-photo" aria-hidden="true">
                <img v-if="p.photoUrl" :src="apiBaseUrl + p.photoUrl" :alt="p.name + ' 프로필 사진'" />
              </div>
              <div class="exec-meta">
                <div class="exec-name">
                  <strong>{{ p.name }}</strong>
                  <span class="exec-role">자문위원</span>
                </div>
                <ul class="exec-desc">
                  <li>{{ p.orgName }}</li>
                  <li>{{ p.position }}</li>
                </ul>
              </div>
            </article>
          </div>
        </section>

      </main>
    </div>
  </section>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { orgChartList as fetchOrgList } from '@/api/org'
const router = useRouter();
const orgList = ref([])
const orgPresidentList = ref([]) // 회장
const orgAuditorList = ref([]) // 감사
const orgVicePresidentList = ref([]) // 부회장
const orgDirectorList = ref([]) // 이사
const orgSecretaryGeneralList = ref([]) // 사무총장
const orgAdvisorList = ref([]) // 자문위원

const apiBaseUrl = process.env.VUE_APP_API_URL; 

const getOrgList = async () => {
  try {
    const param = {
      pageNo: 1,
      countPerRecord: 999,
      search: '',
      typeCd: 'all',
    }

    const result = await fetchOrgList(param)
    if (result?.result === 'ok') {
      orgList.value = result.data || []

      // ✅ category가 president인 데이터만 필터링
      orgPresidentList.value = orgList.value.filter(item => {
        const cat = item.category
        // category가 문자열 또는 객체인 경우 모두 대응
        if (!cat) return false
        if (typeof cat === 'string') return cat === 'president'
        if (typeof cat === 'object') return cat.role === 'president'
        return false
      })

      orgAuditorList.value = orgList.value.filter(item => {
        const cat = item.category
        // category가 문자열 또는 객체인 경우 모두 대응
        if (!cat) return false
        if (typeof cat === 'string') return cat === 'auditor'
        if (typeof cat === 'object') return cat.role === 'auditor'
        return false
      })

      orgVicePresidentList.value = orgList.value.filter(item => {
        const cat = item.category
        // category가 문자열 또는 객체인 경우 모두 대응
        if (!cat) return false
        if (typeof cat === 'string') return cat === 'vice_president'
        if (typeof cat === 'object') return cat.role === 'vice_president'
        return false
      })

      orgDirectorList.value = orgList.value.filter(item => {
        const cat = item.category
        // category가 문자열 또는 객체인 경우 모두 대응
        if (!cat) return false
        if (typeof cat === 'string') return cat === 'director'
        if (typeof cat === 'object') return cat.role === 'director'
        return false
      })

      orgSecretaryGeneralList.value = orgList.value.filter(item => {
        const cat = item.category
        // category가 문자열 또는 객체인 경우 모두 대응
        if (!cat) return false
        if (typeof cat === 'string') return cat === 'secretary_general'
        if (typeof cat === 'object') return cat.role === 'secretary_general'
        return false
      })

      orgAdvisorList.value = orgList.value.filter(item => {
        const cat = item.category
        // category가 문자열 또는 객체인 경우 모두 대응
        if (!cat) return false
        if (typeof cat === 'string') return cat === 'advisor'
        if (typeof cat === 'object') return cat.role === 'advisor'
        return false
      })

    } else {
      orgList.value = []
      orgPresidentList.value = []
      orgAuditorList.value = []
      orgVicePresidentList.value = []
      orgDirectorList.value = []
      orgSecretaryGeneralList.value = []
      orgAdvisorList.value = []

      console.warn(result?.resultMsg ?? '조직 데이터 조회 실패')
    }
  } catch (err) {
    console.error('조직 데이터 조회 오류:', err)
    orgList.value = []
    orgPresidentList.value = []
  }
}


onMounted(async() => {
  await getOrgList()
})

</script>
<style scoped>
/* ========== 래퍼 ========== */
.org-section {
  width: 100%;
  display: flex;
  justify-content: center;
}

.org-wrap {
  max-width: 1200px;
  width: 100%;
  padding: 24px 16px 60px;
  display: grid;
  grid-template-columns: 1fr;   /* ✅ 좌/우 → 위/아래 */
  gap: 36px;
}

/* ========== 좌: 조직안내(이제 상단) ========== */
.org-guide-title {
  margin: 0 0 16px;
  font: 700 26px/1.25 'Noto Sans KR', sans-serif;
  color: #0f172a;
}

.org-guide-title small {
  font: 600 14px/1 'Noto Sans KR', sans-serif;
  color: #1d2088;
  margin-left: 8px;
}

.org-flow {
  display: flex;
  flex-direction: column;
  align-items: center;           /* ✅ 카드 중앙정렬 */
  gap: 28px;
  position: relative;
}

/* 노드 공통 */
.org-node {
  position: relative;
  width: 180px;
  height: 56px;
  border-radius: 8px;
  background: #2e3a46;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font: 700 16px/1 'Noto Sans KR', sans-serif;
}
.org-node-top { background: #0f4f8a; }
.org-node-last::after { display: none; }

/* 세로 연결선(각 노드 아래, 마지막 제외) */
.org-node::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 100%;
  transform: translateX(-50%);
  width: 2px;
  height: 28px;
  background: #cfd6dd;
}

/* ========== 이사회 옆 ‘감사’ 분기 ========== */
.has-audit::before {
  content: "";
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  width: 120px;
  height: 2px;
  background: #cfd6dd;
}
.org-audit {
  position: absolute;
  left: calc(100% + 80px);
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 96px;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #cfd6dd;
  border-radius: 6px;
  font: 600 14px/1 'Noto Sans KR', sans-serif;
  color: #0f172a;
  background: #fff;
}

/* ========== 우: 임원 현황(이제 하단) ========== */
.org-executives-title {
  margin: 0 0 16px;
  font: 700 26px/1.25 'Noto Sans KR', sans-serif;
  color: #0f172a;
}
.org-executives-title small {
  font: 600 14px/1 'Noto Sans KR', sans-serif;
  color: #1d2088;
  margin-left: 8px;
}
.exec-section { margin-top: 8px; }
.exec-heading {
  margin: 0 0 14px;
  font: 700 18px/1.2 'Noto Sans KR', sans-serif;
  color: #0f172a;
}
.exec-divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 20px 0;
}

.exec-card-row { display: grid; grid-template-columns: 1fr; }
.exec-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 18px; }

.exec-card {
  display: grid;
  grid-template-columns: 96px 1fr;
  gap: 14px;
  align-items: center;
  padding: 12px 10px;
  /* border: 1px solid #eef1f4; */
  border-radius: 8px;
  background: #fff;
}
.exec-photo {
  width: 96px; height: 120px;
  border-radius: 4px;
  background: linear-gradient(180deg, #e9eef5, #dfe6ee);
  box-shadow: inset 0 0 0 1px #d3dbe5;
}

.exec-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 이미지 비율 유지하며 꽉 채우기 */
  display: block;
}

.exec-name { display: flex; align-items: center; gap: 8px; margin-bottom: 6px; }
.exec-name strong {
  font: 700 16px/1.2 'Noto Sans KR', sans-serif;
  color: #0f172a;
}
.exec-role {
  font: 700 12px/1 'Noto Sans KR', sans-serif;
  color: #1d2088;
}
.exec-desc { margin: 0; padding-left: 16px; display: grid; gap: 4px; }
.exec-desc li {
  list-style: disc;
  font: 500 14px/1.7 'Noto Sans KR', sans-serif;
  color: #475569;
}

/* ========== 반응형 ========== */
@media (max-width: 1024px) {
  .exec-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 720px) {
  .exec-grid { grid-template-columns: 1fr; }

  /* 감사 분기 간격 축소 */
  .has-audit::before { width: 100px; }
  .org-audit { left: calc(100% + 100px); }
}

.orgchart-image img {
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
  max-width: 1000px; /* 원하는 크기로 조정 가능 */
  border-radius: 8px;
}
</style>
